import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from "moment";
import fileDownload from 'js-file-download';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';

import * as ReactBootStrap from 'react-bootstrap';
import '../tools/css/Iframe.css';
import emptypage from '../tools/images/carpeta.gif';
import BtnVer from '../components/BtnVer';
import Buscar from '../tools/images/Buscar';
import Info from '../tools/images/Info';
import '../tools/css/Home.css';
import LimiteConsultasPruebaGratuita from '../components/LimiteConsultasPruebaGratuita';

import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

const ApiURL=process.env.REACT_APP_API_URL;

var institution_id =sessionStorage.getItem('id_institution');
var token_institucion =sessionStorage.getItem('token');
var id_med_anexo =sessionStorage.getItem('identificacion_profesional');
var url_iframe=process.env.REACT_APP_IFRAME_URL+"/facturacion-citas?token="+token_institucion+"&identificacion="+id_med_anexo

var buscar_consulta='';
var mensaje='';
var id_consulta=0;


class Facturacion extends Component {

  constructor()
    {
     super()
      this.state={
        Consulta: [],
        Pager_Consultas: [],
        pager_infoconsultas:'',
        buscar_consultas:'',
        loading: false,
        loading_recurso:false,
        loading_button: true,
        active_button: true,
        Historia:[],
        diagnostico:[],
        form:{ 
          idconsulta:'',
          nom_paciente:'',
          nom2_paciente:'',
          apell1_paciente:'',
          apell2_paciente:'',
          id_paciente:'',
          eps:'',
          nom_medico:'',
          nom2_medico:'',
          apell1_medico:'',
          apell2_medico:'',
          eps:'',
          fecha_consulta:new Date,           
          }
      }
    }



    render(){ 
      const {form} = this.state; 

     return (

     
        <div className="content-wrapper">

                  <LimiteConsultasPruebaGratuita/>

                  <div className="m24-iframe-fill">
                    <iframe
                      title="Facturacion"
                      src={url_iframe}
                      loading="lazy"
                      allowFullScreen
                      >
                    </iframe>
                  </div>

        </div>


      
      
    )

  }
  
}



export default Facturacion;